import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { NotificationConfigurationModel } from '../../Models/Domains/Threads/NotificationConfigurationModel';
import { NotificationConfiguration } from '../../Models/Domains/Threads/NotificationConfiguration';

declare var IS_RUNNING_IN_APP_POOL;

export class NotificationConfigurationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<NotificationConfigurationModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/NotificationConfiguration/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<NotificationConfigurationModel, any>(url, data);
  }
  public put(configurations: Array<NotificationConfiguration>): Promise<Array<NotificationConfiguration>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/NotificationConfiguration/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { configurations: configurations }

    return AjaxWrapper.put<Array<NotificationConfiguration>, any>(url, data);
  }
}

